const filledDropzone = "_35sfe1xqim";
const emptyDropzone = "_35sebehei0";
const placeholder = "_35sp118u4n6";

export { emptyDropzone, filledDropzone, placeholder };
import "./input.dropzone.style.linaria.module.css";
//# sourceMappingURL=input.dropzone.style.js.map
